import { render, staticRenderFns } from "./GroupCtrCom.vue?vue&type=template&id=c2ac3d98&"
import script from "./GroupCtrCom.vue?vue&type=script&lang=ts&"
export * from "./GroupCtrCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports